export function decodeStringWithAscii(string: string) {
  const el = document.createElement('div');
  el.innerHTML = string;
  return el.innerText;
}
